/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PromptEngineeringStepEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('PROMPT_ENGINEERING_STEP_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class PromptEngineeringStepEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PromptEngineeringStepEnabledSettingParser.decode(input).map(res => new PromptEngineeringStepEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return PromptEngineeringStepEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PromptEngineeringStepEnabledSettingParser.encode(data);
    }
    static schema() {
        return PromptEngineeringStepEnabledSettingParser.schema();
    }
}
